// https://cli.vuejs.org/guide/mode-and-env.html#modes
const env = process.env.NODE_ENV

module.exports = {
  // publicPath: process.env.BASE_URL,

  // Easy checking
  isProduction: env === 'production',
  isDev: env !== 'production',
  isTest: env === 'test'
}
